import { apiRequest, apiEndPoints, methodType } from "./_apiConfig";

// 📌 List all shareholders
export const getShareholdersRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.shareholdersList,
    data,
    true
  );
};

// 📌 Why the declared shareholding does not yet satisfy the KYC step
export const getShareholdingCoverageRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.shareholdingCoverage,
    data,
    true
  );
};

// 📌 Get single shareholder details
export const getShareholderDetailsRequest = async (shareholderId) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.shareholderDetails(shareholderId),
    {},
    true
  );
};

// 📌 Edit / Update shareholder
export const editShareholderRequest = async (shareholderId, data = {}) => {
  return apiRequest(
    methodType.PATCH,
    apiEndPoints.editShareholder(shareholderId),
    data,
    true
  );
};

// 📌 Delete shareholder
export const deleteShareholderRequest = async (shareholderId, data = {}) => {
  return apiRequest(
    methodType.DELETE,
    apiEndPoints.deleteShareholder(shareholderId),
    data,
    true
  );
};

// 📌 Create a new shareholder
export const createShareholderRequest = async (data = {}) => {
  return apiRequest(
    methodType.POST,
    apiEndPoints.createShareholder,
    data,
    true
  );
};